export enum DatePickerChangeDirection {
  DECREASE,
  INCREASE,
  MANUAL,
}
